"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTransactionStatusReponse = validateTransactionStatusReponse;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const statusEnum = zod_1.z.union([zod_1.z.nativeEnum(enums_1.ResponseStatus), zod_1.z.nativeEnum(enums_1.AnchoringStatus)]);
const transactionStatusReponseSchema = zod_1.z
    .object({
    statusCode: zod_1.z.number().nullable(),
    result: zod_1.z.object({
        status: statusEnum,
        rejectReason: zod_1.z.string().optional(),
    }),
})
    .transform(({ statusCode, result }) => ({
    statusCode,
    status: result.status,
    rejectReason: result.rejectReason,
}));
function validateTransactionStatusReponse(input) {
    const result = transactionStatusReponseSchema.safeParse(input);
    if (!result.success) {
        throw new Error("Model does not match TransactionStatusReponse");
    }
    return result.data;
}
//# sourceMappingURL=transactionStatusReponse.js.map